<template>
  <div class="select" v-click-outside:isOpen>
    <span class="selected" @click="toggleOptions">{{ currentValue.name }}</span>
    <ul class="options" v-if="isOpen">
      <li
        :class="currentValue === o ? 'is-selected' : ''"
        v-for="(o, i) in options"
        :key="o + i"
        @click="changeValue(o)"
      >
        {{ o.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Select",
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectDefault: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {
      type: [String, Number],
    },
  },
  watch: {
    value(newValue) {
      let matchingObject = this.options.find((el) => {
        return el.value === newValue;
      });

      if (matchingObject !== undefined) {
        this.changeValue(matchingObject);
      } else {
        console.warn("Value '" + newValue + "' does not match any option in ");
        console.warn(this.$el);
      }
    },
    options() {
      let selected = false;
      for (let o of this.options) {
        if (this.value === o.value) {
          selected = true;
          this.changeValue(o);
          break;
        } else if (o.hasOwnProperty("selected") && o.selected) {
          this.changeValue(o);
          selected = true;
        }
      }
      if (!selected && this.options.length > 0) {
        if (this.options === undefined || this.options || (null && this.options.length <= 0)) {
          this.changeValue(this.options[0]);
        }
      }
    },
  },
  data() {
    return {
      currentValue: {
        name: "",
        value: "",
      },
      lock: 0,
      isOpen: false,
    };
  },
  methods: {
    toggleOptions() {
      this.isOpen = !this.isOpen;
    },
    changeValue(val = null) {
      this.currentValue = val;
      this.isOpen = false;
      this.$emit("input", this.currentValue.value);
    },
  },
  mounted() {
    let selected = false;

    for (let o of this.options) {
      if (this.value === o.value) {
        selected = true;
        this.changeValue(o);
        break;
      } else if (o.hasOwnProperty("selected") && o.selected) {
        this.changeValue(o);
        selected = true;
      }
    }

    if (!selected && this.options.length > 0) {
      if ((this.selectDefault && this.options === undefined) || this.options || (null && this.options.length <= 0)) {
        this.changeValue(this.options[0]);
      } else {
        this.$emit("input", null);
      }
    }
  },
};
</script>

<style scoped></style>
